import { makeStyles } from '@material-ui/core';

type LogoVersion = 'icon' | 'full';

type LogoFullProps = {
  width: string | number;
  height: string | number;
  knockout?: boolean;
  version: LogoVersion;
};

const useStyles = makeStyles({
  house: (props: LogoFullProps) => ({
    width: props.width,
    height: props.height,
  }),
});

const COLORS = Object.freeze({
  brandmark: '#d92228',
  wordmark: '#000000',
  knockout: '#ffffff',
});

const getColor = (defaultColor: string, knockout: boolean = false) => {
  return knockout ? COLORS.knockout : defaultColor;
};

const LogoFull = (props: LogoFullProps) => {
  const classes = useStyles(props);

  return (
    <svg className={classes.house} version="1.1" viewBox="0 0 198 49.5" xmlns="http://www.w3.org/2000/svg">
      <g id="layer1" transform="translate(-6.1527545,-6.8974765)">
        <g id="g10550" transform="matrix(1.7057741,0,0,1.7057741,-18.078931,-47.463763)" style={{ display: 'inline' }}>
          {props.version === 'full' && (
            <g
              aria-label="devportal"
              id="text113"
              style={{ fontSize: '19.8292px', fill: '#d43443', strokeWidth: 1.65243 }}
            >
              <path
                d="m 31.208479,40.990388 q 0,-1.705311 0.634534,-2.994209 0.654364,-1.288898 1.764799,-1.98292 1.110435,-0.694022 2.47865,-0.694022 1.090606,0 1.98292,0.456071 0.912143,0.456072 1.427703,1.229411 v -5.135763 h 3.390793 v 14.673608 h -3.390793 v -1.586336 q -0.475901,0.793168 -1.368215,1.269069 -0.872485,0.475901 -2.042408,0.475901 -1.368215,0 -2.47865,-0.694022 -1.110435,-0.713851 -1.764799,-2.002749 -0.634534,-1.308728 -0.634534,-3.014039 z m 8.288606,0.01983 q 0,-1.269068 -0.713852,-2.002749 -0.694022,-0.73368 -1.705311,-0.73368 -1.011289,0 -1.72514,0.73368 -0.694022,0.713851 -0.694022,1.98292 0,1.269069 0.694022,2.022579 0.713851,0.73368 1.72514,0.73368 1.011289,0 1.705311,-0.73368 0.713852,-0.733681 0.713852,-2.00275 z"
                style={{ fill: getColor(COLORS.brandmark, props.knockout) }}
                id="path5084"
              />
              <path
                d="m 55.776838,40.831755 q 0,0.4759 -0.05949,0.99146 h -7.673901 q 0.07932,1.031118 0.654364,1.586336 0.594876,0.535388 1.447532,0.535388 1.269068,0 1.764799,-1.070777 h 3.608914 q -0.277609,1.090606 -1.011289,1.963091 -0.713851,0.872485 -1.804457,1.368215 -1.090607,0.49573 -2.438992,0.49573 -1.625995,0 -2.895063,-0.694022 -1.269069,-0.694022 -1.982921,-1.98292 -0.713851,-1.288898 -0.713851,-3.014039 0,-1.72514 0.694022,-3.014038 0.713851,-1.288898 1.98292,-1.98292 1.269069,-0.694022 2.914893,-0.694022 1.606165,0 2.855405,0.674193 1.249239,0.674192 1.943261,1.923432 0.713852,1.24924 0.713852,2.914893 z m -3.47011,-0.892314 q 0,-0.872485 -0.594877,-1.388045 -0.594876,-0.515559 -1.48719,-0.515559 -0.852655,0 -1.447531,0.49573 -0.575047,0.49573 -0.713851,1.407874 z"
                style={{ fill: getColor(COLORS.brandmark, props.knockout) }}
                id="path5086"
              />
              <path
                d="m 62.538581,43.369892 2.399333,-7.892022 h 3.608914 L 64.620647,46.542564 H 60.436685 L 56.510504,35.47787 h 3.628743 z"
                style={{ fill: getColor(COLORS.brandmark, props.knockout) }}
                id="path5088"
              />
              <path
                d="m 73.365311,37.044377 q 0.49573,-0.773339 1.368215,-1.249239 0.872485,-0.475901 2.042408,-0.475901 1.368215,0 2.47865,0.694022 1.110435,0.694022 1.74497,1.98292 0.654363,1.288898 0.654363,2.994209 0,1.705311 -0.654363,3.014039 -0.634535,1.288898 -1.74497,2.002749 -1.110435,0.694022 -2.47865,0.694022 -1.150094,0 -2.042408,-0.475901 -0.872485,-0.475901 -1.368215,-1.22941 v 6.821245 H 69.974518 V 35.47787 h 3.390793 z m 4.838325,3.946011 q 0,-1.269069 -0.713851,-1.98292 -0.694022,-0.73368 -1.72514,-0.73368 -1.01129,0 -1.725141,0.73368 -0.694022,0.733681 -0.694022,2.002749 0,1.269069 0.694022,2.00275 0.713851,0.73368 1.725141,0.73368 1.011289,0 1.72514,-0.73368 0.713851,-0.75351 0.713851,-2.022579 z"
                style={{ fill: getColor(COLORS.wordmark, props.knockout) }}
                id="path5090"
              />
              <path
                d="m 88.475143,46.701198 q -1.625994,0 -2.934721,-0.694022 -1.288898,-0.694022 -2.042408,-1.98292 -0.73368,-1.288898 -0.73368,-3.014039 0,-1.705311 0.753509,-2.994209 0.75351,-1.308727 2.062237,-2.002749 1.308727,-0.694022 2.934722,-0.694022 1.625994,0 2.934722,0.694022 1.308727,0.694022 2.062236,2.002749 0.75351,1.288898 0.75351,2.994209 0,1.705312 -0.773339,3.014039 -0.753509,1.288898 -2.082066,1.98292 -1.308727,0.694022 -2.934722,0.694022 z m 0,-2.934722 q 0.971631,0 1.645824,-0.713851 0.694022,-0.713851 0.694022,-2.042408 0,-1.328556 -0.674193,-2.042407 -0.654363,-0.713852 -1.625994,-0.713852 -0.99146,0 -1.645824,0.713852 -0.654363,0.694022 -0.654363,2.042407 0,1.328557 0.634534,2.042408 0.654364,0.713851 1.625994,0.713851 z"
                style={{ fill: getColor(COLORS.wordmark, props.knockout) }}
                id="path5092"
              />
              <path
                d="m 99.4605,37.321986 q 0.59488,-0.912143 1.48719,-1.427702 0.89231,-0.535389 1.98292,-0.535389 v 3.589086 h -0.93197 q -1.26907,0 -1.90361,0.555217 -0.63453,0.535389 -0.63453,1.903603 v 5.135763 H 96.069706 V 35.47787 H 99.4605 Z"
                style={{ fill: getColor(COLORS.wordmark, props.knockout) }}
                id="path5094"
              />
              <path
                d="m 110.72348,43.66733 v 2.875234 h -1.72514 q -1.84412,0 -2.87523,-0.892314 -1.03112,-0.912143 -1.03112,-2.954551 V 38.293617 H 103.7436 V 35.47787 h 1.34839 v -2.696771 h 3.39079 v 2.696771 h 2.22087 v 2.815747 h -2.22087 v 4.441741 q 0,0.49573 0.23795,0.713851 0.23795,0.218121 0.79317,0.218121 z"
                style={{ fill: getColor(COLORS.wordmark, props.knockout) }}
                id="path5096"
              />
              <path
                d="m 111.93303,40.990388 q 0,-1.705311 0.63453,-2.994209 0.65437,-1.288898 1.7648,-1.98292 1.11044,-0.694022 2.47865,-0.694022 1.16992,0 2.04241,0.475901 0.89231,0.4759 1.36821,1.249239 V 35.47787 h 3.3908 v 11.064694 h -3.3908 v -1.566506 q -0.49573,0.773338 -1.38804,1.249239 -0.87249,0.475901 -2.04241,0.475901 -1.34838,0 -2.45882,-0.694022 -1.11043,-0.713851 -1.7648,-2.002749 -0.63453,-1.308728 -0.63453,-3.014039 z m 8.2886,0.01983 q 0,-1.269068 -0.71385,-2.002749 -0.69402,-0.73368 -1.70531,-0.73368 -1.01129,0 -1.72514,0.73368 -0.69402,0.713851 -0.69402,1.98292 0,1.269069 0.69402,2.022579 0.71385,0.73368 1.72514,0.73368 1.01129,0 1.70531,-0.73368 0.71385,-0.733681 0.71385,-2.00275 z"
                style={{ fill: getColor(COLORS.wordmark, props.knockout) }}
                id="path5098"
              />
              <path
                d="m 129.46202,31.868956 v 14.673608 h -3.3908 V 31.868956 Z"
                style={{ fill: getColor(COLORS.wordmark, props.knockout) }}
                id="path5100"
              />
            </g>
          )}
          <g id="g340" transform="matrix(0.00499365,0,0,-0.00499365,63.068465,46.746893)">
            <path
              id="rect4106-0"
              style={{ display: 'inline', fill: props.knockout ? 'transparent' : '#ffffff', strokeWidth: 23.8457 }}
              transform="scale(1,-1)"
              d="m -8960.418,-1939.2683 h 1474.1703 V -190.4375 H -8960.418 Z"
            />
            <path
              d="m -9784.9834,1402.9909 h 471.168 V -10.729148 h 2147.302 V 1402.9909 h 470.8 l -1543.16,1576.38 z m 1683.44,375.2 0.68,0.63 c 56.39,46.67 137.65,100.23 267.04,100.23 77.94,0 143.43,-22.39 184.32,-63.02 38.15,-42.1 56.44,-92.76 56.44,-155.46 0,-91.4 -57.55,-183.84 -167.6,-183.84 -111.16,0 -149.63,68.79 -176.96,133.28 -23.49,56.66 -44.62,91.71 -77.41,91.71 -85.62,0 -216.48,-193.72 -250.59,-434.33 -3.26,-39.05 -6.84,-127.18 -6.84,-217.95 V 747.91885 c 0,-172.277 17.35,-242.488 47.36,-305.449 20.49,-37.211 39.05,-57.027 61.8,-65.488 30.28,-13.301 52.72,-16.5 83.67,-19.922 l 12.72,-1.418 v -42.621 h -749.875 v 42.41 l 12.563,1.582 c 34.842,4.36 65.122,12.09 90.032,23.117 43.88,21.821 65.8,41.789 85.93,107.961 11.24,67.692 13.56,169.172 13.56,242.539 v 723.86105 c 0,54.4 0,181.85 -10.04,225.26 -5.94,37.9 -24.91,67.22 -56.71,88.3 -35.58,25.7 -74.21,28.9 -115.151,32.27 l -13.141,1.1 -0.05,42.99 h 502.122 c 26.6,0 38.68,-18.13 38.68,-35 0,-8.09 -1.42,-76.1 -3.05,-154.94 -1.05,-50.35 -2.15,-104.53 -2.94,-144.27 53.45,141.43 117.1,214.8 173.44,267.99"
              style={{
                fill: getColor(COLORS.brandmark, props.knockout),
                fillOpacity: 1,
                fillRule: 'nonzero',
                stroke: 'none',
              }}
              id="path342"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

LogoFull.defaultProps = {
  width: 'auto',
  height: 40,
  fill: '#ffffff',
  version: 'full',
};

export default LogoFull;
